import { Component, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../../../auth/auth.service';
import { MenuService } from '../menu.service';
import { Menu } from '../../../../asistente-en-linea/models/Menu';
import { AreaFuncionalGAFU } from '../../../models/area-funcional-gafu';
import { Role } from "../../../models/role";

@Component({
  selector: 'app-editing-menu',
  templateUrl: './editing-menu.component.html',
  styleUrls: ['./editing-menu.component.scss']
})
export class EditingMenuComponent implements OnInit {
  cargandoDatos: boolean;
  menuSeleccionado: Menu;
  descripcion: string;
  texto: string;
  areasFuncionalesGAFU: AreaFuncionalGAFU[];
  areaFuncionalSeleccionada: AreaFuncionalGAFU;
  gafuAreaFuncional: string;
  idMenu: string;
  idMenuBD: string;
  loading: boolean;
  habilitado: boolean;
  errorValidacionCreacionMenu: boolean;
  esUsuarioAdminitrador: boolean;
  error: string;
  opcionesHabilitado: { value: string, texto: string }[] = [{ value: "true", texto: "Habilitado" }, { value: "false", texto: "Deshabilitado" }];
  constructor(private menuService: MenuService, private route: ActivatedRoute, private router: Router, private authService: AuthService) {
    this.loading = false;
    this.errorValidacionCreacionMenu = false;
    this.esUsuarioAdminitrador = false;
    this.idMenu = "1";
    // this.habilitado = false;
  }



  ngOnInit() {
    this.areasFuncionalesGAFU = [];
    for (let role of this.authService.getUser().roles) {
      if (role == Role.Admin || role == Role.MenuAdministrator) {
        this.esUsuarioAdminitrador = true;
        break;
      }
    }
    //this.esUsuarioAdminitrador = false;
    if (!this.esUsuarioAdminitrador) {
      this.areasFuncionalesGAFU.push(new AreaFuncionalGAFU("Acceso a todas las areas funcionales", "*", "Todos"));
      for (let area of this.authService.getUser().areasFuncionales) {
        this.areasFuncionalesGAFU.push(area);
      }
    }

    this.route.queryParamMap.subscribe((params: any) => {
      this.idMenu = params.params.idMenu;
      this.idMenuBD = this.idMenu;
      this.loadMenu(this.idMenu);
    })
  }

  irPaginaInicio() {
    this.router.navigate(['/config/home/']);
  }

  cancelOperation() {
    this.irPaginaInicio();
  }
  async applyOperation() {
    let resArray = [];
    this.errorValidacionCreacionMenu = false;
    if (this.isCreateMenuDataValid()) {
      this.loading = true;
      let idDest;
      let idDestFin = 0;
      // resArray.push(await this.menuService.actualizarMenu(this.idMenuBD, this.idMenu, this.descripcion, this.texto, this.gafuAreaFuncional, this.authService.getUser().username, this.habilitado).toPromise().catch((err) => {
      //   this.loading = false;
      //   alert(err);
      // }));

      let noErr = resArray.reduce((previous, current) => {
        idDest = current.id;
        return previous && (current.statusCode == 200 || current.statusCode == 0 ? true : false);
      }, true)

      if (noErr) {
        if (idDest) {
          idDestFin = Number(idDest);
        }
        if (idDestFin < 0) {
          if (idDest === '-1') {
            this.error = "Atención: Ya existe otro menú con el mismo identificador";
          } else if (idDest === '-2') {
            this.error = "Atención: Ya existe otro menú con el mismo nombre";
          } else if (idDest === '-3') {
            this.error = "Atención: Ya existe otro menú con el mismo identificador y nombre";
          } else if (idDest === '-4') {
            this.error = "Ocurrió un error: Ya identificador original del menú es obligatorio";
          } else {
            this.error = "Ocurrió un error, intente nuevamente más tade";
          }
          this.errorValidacionCreacionMenu = true;
        } else {
          this.irPaginaInicio();
        }
        this.loading = false;
      } else {
        this.loading = false;
        alert("Ocurrió un error, intente nuevamente más tade");
      }
    } else {
      this.errorValidacionCreacionMenu = true;
    }

  }
  loadMenu(idMenu) {
    this.cargandoDatos = true;
    // this.menuService.loadMenuByID(idMenu).subscribe((data: any) => {
    //   if (data && (data.statusCode == 200 || data.statusCode == 0)) {
    //     let menuBD = data.content;
    //     this.habilitado = menuBD.habilitado != null ? menuBD.habilitado : false;
    //     this.descripcion = menuBD.descripcion;
    //     this.texto = menuBD.texto;
    //     this.gafuAreaFuncional = menuBD.gafuAreaFuncional;
    //     for (let area of this.areasFuncionalesGAFU) {
    //       if (area.areaFuncional == this.gafuAreaFuncional) {
    //         this.areaFuncionalSeleccionada = area;
    //         break;
    //       }
    //     }
    //     this.cargandoDatos = false;
    //   }
    //   else {
    //     alert(data.statusMessage);
    //     this.cargandoDatos = false;
    //   }
    // },
    //   error => {
    //     alert(error);
    //     this.cargandoDatos = false;
    //   })
  }

  asignarValorArea() {
    this.gafuAreaFuncional = this.areaFuncionalSeleccionada ? this.areaFuncionalSeleccionada.areaFuncional : "";
  }

  keyPressAlphaNumericWithCharacters(event) {
    var inp = String.fromCharCode(event.keyCode);
    // Allow numbers, alpahbets,, undercore
    if (/[a-zA-Z0-9-_]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  onPaste(e) {
    e.preventDefault();
    return false;
  }

  isCreateMenuDataValid() {
    if (this.idMenu && this.descripcion && this.texto && this.gafuAreaFuncional) {
      if (this.idMenu.length > 10) {
        this.error = "Atención: El identificador del menú no puede superar los 10 caracteres";
        return false;
      } else {
        if (/\s/.test(this.idMenu)) {
          this.error = "Atención: El identificador no puede contener espacios en blanco";
          return false;
        } else {
          let isValid = /[a-zA-Z0-9-_]/.test(this.idMenu);
          if (!isValid) {
            this.error = "Atención: El identificador no puede contener caracteres especiales. Solo se admiten números, letras y los caracteres - y _";
            return false;
          }
        }
      }
      if (this.descripcion.length > 60) {
        this.error = "Atención: El nombre del menú no puede superar los 60 caracteres";
        return false;
      }
      if (this.texto.length > 250) {
        this.error = "Atención: La descripción del menú no puede superar los 250 caracteres";
        return false;
      }
      if (this.gafuAreaFuncional.length > 20) {
        this.error = "Atención: El código de área funcional del menú no puede superar los 20 caracteres";
        return false;
      }
      return true;
    } else {
      this.error = "Por favor, asegúrese de ingresar todos los campos obligatorios";
      return false;
    }
  }

  salirAdministrador() {
    this.menuService.salirAdministrador();
    this.router.navigate(["/login"]);
  }
}